import { forwardRef, type InputHTMLAttributes, type TextareaHTMLAttributes } from 'react';
import { cn } from '../lib/cn.js';

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className, ...rest }, ref) => (
    <input
      ref={ref}
      className={cn(
        'h-11 px-3 rounded-xl bg-neutral-900 border border-neutral-800',
        'text-neutral-100 placeholder:text-neutral-500',
        'focus:outline-none focus:border-blue-600 focus:ring-2 focus:ring-blue-600/20',
        'disabled:opacity-50',
        className,
      )}
      {...rest}
    />
  ),
);
Input.displayName = 'Input';

export const Textarea = forwardRef<
  HTMLTextAreaElement,
  TextareaHTMLAttributes<HTMLTextAreaElement>
>(({ className, ...rest }, ref) => (
  <textarea
    ref={ref}
    className={cn(
      'px-3 py-2 rounded-xl bg-neutral-900 border border-neutral-800',
      'text-neutral-100 placeholder:text-neutral-500',
      'focus:outline-none focus:border-blue-600 focus:ring-2 focus:ring-blue-600/20',
      'font-mono text-sm min-h-24 resize-y',
      className,
    )}
    {...rest}
  />
));
Textarea.displayName = 'Textarea';
